(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bulk-inventory"] && !Shopify.designMode) return;
  try {
    
(function(){
  var $table = document.getElementById('bi-table');
  if (!$table) return;

  var rows = Array.prototype.slice.call($table.querySelectorAll('tbody .bi-row'));
  var search = document.getElementById('bi-search');
  var hideZero = document.getElementById('bi-hide-zero');
  var sortSel = document.getElementById('bi-sort');

  function applyFilters(){
    var q = (search && search.value || '').toLowerCase().trim();
    var hz = hideZero && hideZero.checked;
    var anySearch = q.length > 0;

    rows.forEach(function(r){
      var title = (r.getAttribute('data-title') || '').toLowerCase();
      var variant = (r.getAttribute('data-variant') || '').toLowerCase();
      var sku = (r.getAttribute('data-sku') || '').toLowerCase();
      var qty = parseInt(r.getAttribute('data-qty') || '0', 10);

      var matches = !q || title.indexOf(q) > -1 || variant.indexOf(q) > -1 || sku.indexOf(q) > -1;
      var okQty = !hz || qty > 0;

      // if filtered, re-show product title so it doesn't disappear
      var productCell = r.querySelector('.bi-product');
      if (productCell) {
        if (anySearch && matches) {
          var existingLink = productCell.querySelector('a');
          if (!existingLink) {
            productCell.innerHTML = '<a href="/products/' + encodeURIComponent(title.replace(/ /g, '-').toLowerCase()) + '" target="_blank" style="color:#111;text-decoration:underline;">' + r.getAttribute('data-title') + '</a>';
          }
        }
      }

      r.style.display = (matches && okQty) ? '' : 'none';
    });
  }

  function applySort(){
    if (!sortSel) return;
    var val = sortSel.value;
    if (!val) return;

    var tbody = $table.querySelector('tbody');
    var list = rows.slice();

    list.sort(function(a,b){
      var qa = parseInt(a.getAttribute('data-qty') || '0', 10);
      var qb = parseInt(b.getAttribute('data-qty') || '0', 10);
      var ta = (a.getAttribute('data-title') || '').toLowerCase();
      var tb = (b.getAttribute('data-title') || '').toLowerCase();
      var pa = parseFloat((a.querySelector('td:nth-child(4)').textContent || '').replace(/[^0-9.]/g,'')) || 0;
      var pb = parseFloat((b.querySelector('td:nth-child(4)').textContent || '').replace(/[^0-9.]/g,'')) || 0;

      switch(val){
        case 'prod-asc':  return ta.localeCompare(tb);
        case 'prod-desc': return tb.localeCompare(ta);
        case 'qty-asc':   return qa - qb;
        case 'qty-desc':  return qb - qa;
        case 'price-asc': return pa - pb;
        case 'price-desc': return pb - pa;
        default: return 0;
      }
    });

    list.forEach(function(r){ tbody.appendChild(r); });
    applyFilters();
  }

  if (search) search.addEventListener('input', applyFilters);
  if (hideZero) hideZero.addEventListener('change', applyFilters);
  if (sortSel) sortSel.addEventListener('change', applySort);
})();

  } catch(e) { console.error(e); }
})();
})();
